import React, { useMemo } from "react";
import { Filter, RotateCcw, X } from "lucide-react";
import { CAMPAIGN_THEME } from "../ui/ThemeDateInput";
import {
  buildAppliedFilterChips,
  hasActiveCampaignFilters,
} from "../../utils/campaignFilterLabels";

export default function CampaignAppliedFiltersBar({
  filters,
  phoneAccounts = [],
  templates = [],
  onRemoveFilter,
  onClearAll,
  onEditFilters,
  loading = false,
}) {
  const chips = useMemo(
    () => buildAppliedFilterChips(filters, { phoneAccounts, templates }),
    [filters, phoneAccounts, templates]
  );

  if (!hasActiveCampaignFilters(filters)) {
    return null;
  }

  return (
    <div
      className="mb-4 rounded-2xl border border-gray-200 shadow-sm overflow-hidden"
      style={{ backgroundColor: CAMPAIGN_THEME.surface }}
    >
      <div className="px-4 py-3 flex flex-col sm:flex-row sm:items-center gap-3">
        <div className="flex items-center gap-2 shrink-0">
          <div
            className="flex items-center justify-center w-8 h-8 rounded-lg border border-gray-200 shadow-sm"
            style={{ backgroundColor: CAMPAIGN_THEME.accent }}
          >
            <Filter size={14} className="text-gray-900" />
          </div>
          <div>
            <p className="text-xs font-bold text-gray-900">Applied filters</p>
            <p className="text-[10px] text-gray-600">
              {chips.length} active{loading ? " · updating…" : ""}
            </p>
          </div>
        </div>

        <div className="flex flex-wrap items-center gap-2 flex-1 min-w-0">
          {chips.map((chip) => (
            <span
              key={chip.key}
              className="inline-flex items-center gap-1.5 pl-2.5 pr-1 py-1 rounded-lg text-xs font-semibold text-gray-800 border border-gray-200 bg-white shadow-sm max-w-full"
            >
              <span className="truncate">{chip.label}</span>
              <button
                type="button"
                onClick={() => onRemoveFilter(chip.field)}
                disabled={loading}
                className="p-0.5 rounded-md hover:bg-gray-100 text-gray-400 hover:text-gray-700 transition-colors disabled:opacity-50"
                aria-label={`Remove ${chip.label}`}
              >
                <X size={12} />
              </button>
            </span>
          ))}
        </div>

        <div className="flex items-center gap-2 shrink-0">
          {onEditFilters && (
            <button
              type="button"
              onClick={onEditFilters}
              className="px-3 py-1.5 text-xs font-semibold text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors shadow-sm"
            >
              Edit filters
            </button>
          )}
          <button
            type="button"
            onClick={onClearAll}
            disabled={loading}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors shadow-sm disabled:opacity-50"
          >
            <RotateCcw size={12} />
            Clear all
          </button>
        </div>
      </div>
    </div>
  );
}
